/**
 * Validates if a CSS style value should be included in the style object.
 * Filters out undefined, null, empty strings, and zero-equivalent values
 * to ensure consistent SSR and client-side rendering.
 */
export const isValidStyleValue = (value) => {
    // First check for falsy values
    if (value === undefined || value === null || value === '' || value === 'px' || value === '0px') {
        return false;
    }
    
    // Check for numeric zero
    if (value === 0 || value === '0') {
        return false;
    }
    
    // Handle string values
    if (typeof value === 'string') {
        const trimmed = value.trim();
        
        // Empty or whitespace-only strings
        if (trimmed === '') {
            return false;
        }
        
        // Common invalid CSS values
        if (trimmed === 'px' || trimmed === '0px' || trimmed === '0' || 
            trimmed === 'undefined' || trimmed === 'null') {
            return false;
        }
        
        // Values that are effectively zero
        if (trimmed === '0px 0px' || trimmed === '0px 0px 0px 0px' || 
            trimmed === '0 0' || trimmed === '0 0 0 0') {
            return false;
        }
        
        // Check for strings that only contain invalid characters
        if (/^[px\s]*$/.test(trimmed)) {
            return false;
        }
    }
    
    return true;
};

/**
 * Creates a style object with only valid CSS properties.
 * Ensures consistent rendering between server and client.
 */
export const createValidStyleObject = (styleProps) => {
    const styles = {};
    
    Object.entries(styleProps).forEach(([key, value]) => {
        if (isValidStyleValue(value)) {
            styles[key] = value;
        }
    });
    
    return styles;
};